import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomurudeshwarcab() {



    const cardData = {




keyword: "Belgaum to Murudeshwar Cab",

headingDescription: "Belgaum Taxi Service provides comfortable and reliable Belgaum to Murudeshwar cab services for family trips, pilgrimage tours, beach vacations, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Murudeshwar, we offer safe and convenient transportation with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel requirements. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support for a smooth journey. Belgaum Taxi Service connects travelers from Belgaum to Murudeshwar with comfortable cab solutions for visiting temples, beaches, resorts, and nearby coastal destinations across Karnataka.",

topPlaces: [
  {
    title: "Murudeshwar Temple",
    description: "Murudeshwar Temple is a famous pilgrimage destination known for the massive Shiva statue, beautiful temple architecture, and scenic Arabian Sea views. It attracts devotees and tourists throughout the year."
  },
  {
    title: "Murudeshwar Beach",
    description: "Murudeshwar Beach is a peaceful coastal attraction known for its clean shoreline, relaxing atmosphere, and beautiful sunset views, making it ideal for family vacations."
  },
  {
    title: "Netrani Island",
    description: "Netrani Island is a popular adventure destination near Murudeshwar, famous for scuba diving, snorkeling, and marine life experiences."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a scenic coastal town known for Om Beach, Kudle Beach, temples, and peaceful surroundings. It is a popular destination for travelers exploring Karnataka's coastline."
  },
  {
    title: "Udupi",
    description: "Udupi is a famous coastal city known for Sri Krishna Temple, beautiful beaches, traditional cuisine, and cultural attractions."
  },
  {
    title: "Mangalore",
    description: "Mangalore is a major coastal city known for beaches, temples, educational institutions, business centers, and Mangalore Airport connectivity."
  },
  {
    title: "Coorg",
    description: "Coorg is a beautiful hill station famous for coffee plantations, waterfalls, forests, and pleasant weather, making it a popular getaway destination."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's leading technology and business hub with IT parks, corporate offices, and commercial centers. It is a preferred destination for long-distance cab travel."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination known for beaches, resorts, churches, and sightseeing attractions. Travelers often combine coastal trips with Goa visits."
  },
  {
    title: "Hampi",
    "description": "Hampi is a UNESCO World Heritage Site famous for ancient ruins, temples, and historical monuments, making it a popular heritage destination in Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Murudeshwar Cab",
    "description": "Book Belgaum to Murudeshwar Cab for a comfortable and safe journey with professional chauffeurs and well-maintained AC vehicles. Travel conveniently to Murudeshwar Temple, Shiva Statue, and nearby coastal attractions with Sedan, Ertiga, Innova Crysta, and SUV cab options available for one way and round trip travel."
  },
  {
    "name": "Belgaum to Murudeshwar Taxi",
    "description": "Hire Belgaum to Murudeshwar Taxi service for reliable outstation travel with experienced drivers, clean cars, affordable fares, and flexible booking options. Enjoy a smooth journey for family trips, pilgrimage visits, sightseeing tours, and personal travel requirements."
  },
  {
    "name": "Belgaum to Murudeshwar Cab Service",
    "description": "Choose Belgaum to Murudeshwar Cab Service for convenient long-distance transportation with professional drivers, comfortable vehicles, transparent pricing, and 24x7 customer support. Our cab services are ideal for temple visits, holidays, corporate travel, and weekend trips."
  },
  {
    "name": "Belgaum to Murudeshwar Taxi Service",
    "description": "Book Belgaum to Murudeshwar Taxi Service for affordable and comfortable travel solutions. Get chauffeur-driven AC taxis with doorstep pickup, flexible schedules, and multiple vehicle choices for families, groups, and individual passengers."
  },
  {
    "name": "Belgaum to Murudeshwar One Way Cab",
    "description": "Reserve Belgaum to Murudeshwar One Way Cab for economical single-trip travel without return fare charges. Enjoy fixed pricing, comfortable seating, professional drivers, and hassle-free transportation from Belgaum to Murudeshwar."
  },
  {
    "name": "Belgaum to Murudeshwar Cab Booking",
    "description": "Complete Belgaum to Murudeshwar Cab Booking online with easy reservations, instant confirmation, and multiple car options. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel needs."
  },
  {
    "name": "Belgaum to Murudeshwar Car Rental",
    "description": "Choose Belgaum to Murudeshwar Car Rental for flexible chauffeur-driven vehicle services. Hire comfortable cars for temple tours, family vacations, beach trips, sightseeing, and long-distance travel with affordable packages."
  },
  {
    "name": "Belgaum to Murudeshwar Outstation Cab",
    "description": "Book Belgaum to Murudeshwar Outstation Cab for safe and reliable intercity travel. Enjoy clean AC vehicles, experienced chauffeurs, flexible one way and round trip options, and convenient pickup facilities."
  },
  {
    "name": "Belgaum to Murudeshwar Tour Package",
    "description": "Plan your Belgaum to Murudeshwar Tour Package with comfortable cab services covering Murudeshwar Temple, Shiva Statue, beaches, and nearby tourist attractions. Enjoy customized sightseeing packages with professional drivers."
  },
  {
    "name": "Belgaum to Murudeshwar Taxi Booking",
    "description": "Book Belgaum to Murudeshwar Taxi Booking services for a smooth travel experience with quick confirmation and reliable transportation. Get premium vehicles and experienced drivers for your journey."
  },
  {
    "name": "Belgaum to Murudeshwar Innova Crysta Cab",
    "description": "Hire Belgaum to Murudeshwar Innova Crysta Cab for spacious and premium travel. Enjoy luxury seating, large luggage space, and comfortable journeys suitable for families, groups, and pilgrimage tours."
  },
  {
    "name": "Belgaum to Murudeshwar Ertiga Cab",
    "description": "Book Belgaum to Murudeshwar Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors and professional chauffeurs. Perfect for family trips, temple visits, and outstation journeys."
  },
  {
    "name": "Belgaum to Murudeshwar Sedan Cab",
    "description": "Choose Belgaum to Murudeshwar Sedan Cab for economical and comfortable travel. Enjoy clean AC sedan cars with experienced drivers suitable for couples, small families, business trips, and personal journeys."
  },
  {
    "name": "Belgaum to Murudeshwar Round Trip Cab",
    "description": "Hire Belgaum to Murudeshwar Round Trip Cab for convenient return travel with affordable packages and flexible schedules. Ideal for temple tours, family vacations, sightseeing trips, and weekend holidays."
  },
  {
    "name": "Belgaum to Murudeshwar Private Taxi",
    "description": "Book Belgaum to Murudeshwar Private Taxi for personalized travel with dedicated vehicles and professional drivers. Enjoy privacy, comfort, and flexible travel arrangements for family and personal trips."
  },
  {
    "name": "Cheap Belgaum to Murudeshwar Cab",
    "description": "Find Cheap Belgaum to Murudeshwar Cab services with budget-friendly fares, quality vehicles, and reliable chauffeur support. Travel comfortably without compromising safety and service quality."
  },
  {
    "name": "Best Belgaum to Murudeshwar Cab Service",
    "description": "Choose the Best Belgaum to Murudeshwar Cab Service offering premium vehicles, skilled drivers, affordable rates, and dependable travel solutions. Enjoy a smooth and comfortable journey from Belgaum to Murudeshwar."
  },
  {
    "name": "Online Belgaum to Murudeshwar Cab Booking",
    "description": "Complete Online Belgaum to Murudeshwar Cab Booking with simple booking procedures, instant confirmation, and multiple vehicle categories. Get convenient cab reservations for temple tours, family trips, and holidays."
  },
  {
    "name": "Belgaum to Murudeshwar Taxi Fare",
    "description": "Check Belgaum to Murudeshwar Taxi Fare with transparent pricing and flexible cab packages. Choose suitable vehicles based on passenger requirements, luggage capacity, and travel preferences."
  },
  {
    "name": "Belgaum to Murudeshwar Car Hire",
    "description": "Hire Belgaum to Murudeshwar Car Hire services with professional drivers and comfortable vehicles. Suitable for sightseeing tours, religious trips, corporate travel, and personal transportation."
  },
  {
    "name": "Belgaum to Murudeshwar Cab Price",
    "description": "Get affordable Belgaum to Murudeshwar Cab Price with multiple vehicle options. Book reliable AC cabs with transparent rates for one way, round trip, and customized travel plans."
  },
  {
    "name": "Belgaum to Murudeshwar Temple Tour by Cab",
    "description": "Book Belgaum to Murudeshwar Temple Tour by Cab for a peaceful pilgrimage journey. Visit the famous Murudeshwar Temple and Shiva Statue with comfortable vehicles and experienced drivers."
  },
  {
    "name": "Belgaum to Murudeshwar Shiva Statue Tour",
    "description": "Plan Belgaum to Murudeshwar Shiva Statue Tour with reliable cab services. Travel comfortably to explore the iconic Shiva Statue, temple surroundings, and beautiful coastal locations."
  },
  {
    "name": "Belgaum to Murudeshwar Family Cab",
    "description": "Choose Belgaum to Murudeshwar Family Cab for safe and comfortable family travel. Get spacious vehicles, professional drivers, and flexible options for vacations and pilgrimage journeys."
  },
  {
    "name": "Belgaum to Murudeshwar Corporate Cab",
    "description": "Book Belgaum to Murudeshwar Corporate Cab services for business travel and executive transportation. Enjoy premium vehicles with professional chauffeurs and reliable travel support."
  },
  {
    "name": "Belgaum to Murudeshwar Beach Tour Package",
    "description": "Enjoy Belgaum to Murudeshwar Beach Tour Package with comfortable cab services covering coastal attractions and sightseeing destinations. Plan relaxing holidays with customized travel packages."
  },
  {
    "name": "Belgaum to Murudeshwar Cab Fare",
    "description": "Get details about Belgaum to Murudeshwar Cab Fare with affordable and transparent pricing. Select from Sedan, Ertiga, Innova Crysta, and SUV options based on your journey requirements."
  },
  {
    "name": "Belgaum to Murudeshwar Taxi Near Me",
    "description": "Find Belgaum to Murudeshwar Taxi Near Me for quick and reliable cab booking. Get nearby taxi availability with professional drivers and comfortable vehicles for outstation travel."
  },
  {
    "name": "Belgaum to Murudeshwar Holiday Package",
    "description": "Plan Belgaum to Murudeshwar Holiday Package with comfortable cab services for sightseeing, temple visits, and beach exploration. Enjoy customized travel plans with experienced chauffeurs."
  },
  {
    "name": "Murudeshwar Cab Service",
    "description": "Book Murudeshwar Cab Service for local sightseeing, temple visits, airport transfers, and outstation travel. Get reliable vehicles with professional drivers for comfortable journeys."
  },
  {
    "name": "Kollur to Murudeshwar Taxi",
    "description": "Hire Kollur to Murudeshwar Taxi for a comfortable pilgrimage journey connecting two famous destinations. Enjoy reliable cab services with experienced drivers and well-maintained vehicles."
  },
  {
    "name": "Kollur to Murudeshwar Taxi Fare",
    "description": "Check Kollur to Murudeshwar Taxi Fare and book affordable transportation options. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for convenient temple travel."
  }
],
"tableData": [
  ["Belgaum to Murudeshwar Cab", "Belgaum to Murudeshwar Taxi"],
  ["Belgaum to Murudeshwar Cab Service", "Belgaum to Murudeshwar Taxi Service"],
  ["Belgaum to Murudeshwar One Way Cab", "Belgaum to Murudeshwar Cab Booking"],
  ["Belgaum to Murudeshwar Car Rental", "Belgaum to Murudeshwar Outstation Cab"],
  ["Belgaum to Murudeshwar Tour Package", "Belgaum to Murudeshwar Taxi Booking"],
  ["Belgaum to Murudeshwar Innova Crysta Cab", "Belgaum to Murudeshwar Ertiga Cab"],
  ["Belgaum to Murudeshwar Sedan Cab", "Belgaum to Murudeshwar Round Trip Cab"],
  ["Belgaum to Murudeshwar Private Taxi", "Cheap Belgaum to Murudeshwar Cab"],
  ["Best Belgaum to Murudeshwar Cab Service", "Online Belgaum to Murudeshwar Cab Booking"],
  ["Belgaum to Murudeshwar Taxi Fare", "Belgaum to Murudeshwar Car Hire"],
  ["Belgaum to Murudeshwar Cab Price", "Belgaum to Murudeshwar Temple Tour by Cab"],
  ["Belgaum to Murudeshwar Shiva Statue Tour", "Belgaum to Murudeshwar Family Cab"],
  ["Belgaum to Murudeshwar Corporate Cab", "Belgaum to Murudeshwar Beach Tour Package"],
  ["Belgaum to Murudeshwar Cab Fare", "Belgaum to Murudeshwar Taxi Near Me"],
  ["Belgaum to Murudeshwar Holiday Package", "Murudeshwar Cab Service"],
  ["Kollur to Murudeshwar Taxi", "Kollur to Murudeshwar Taxi Fare"]
],





whychoose: [
  {
    WhyChooseheading: "Convenient Belgaum to Murudeshwar Cab Service",
    WhyChoosedescription: "Enjoy a comfortable coastal journey from Belgaum to Murudeshwar with reliable taxi options, experienced drivers, and vehicles designed for long-distance travel."
  },
  {
    WhyChooseheading: "Perfect Cab Choice for Temple & Beach Trips",
    WhyChoosedescription: "Our Belgaum to Murudeshwar taxis are suitable for family vacations, temple visits, sightseeing tours, and weekend getaways along the Karnataka coast."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Group",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs depending on your group size, luggage, and travel comfort needs."
  },
  {
    WhyChooseheading: "Pickup Facility Across Belgaum",
    WhyChoosedescription: "Start your journey with convenient pickup from homes, hotels, offices, railway station, airport areas, and other preferred locations in Belgaum."
  },
  {
    WhyChooseheading: "Experienced Drivers for Coastal Routes",
    WhyChoosedescription: "Our professional chauffeurs understand highway routes and provide a smooth travel experience with safe and comfortable driving."
  },
  {
    WhyChooseheading: "Flexible Travel Packages",
    WhyChoosedescription: "Select a one-way taxi, round-trip cab, or customized travel package according to your Murudeshwar trip schedule."
  },
  {
    WhyChooseheading: "Spacious & Well-Maintained Vehicles",
    WhyChoosedescription: "Travel comfortably with clean cars, good seating space, and properly maintained vehicles suitable for extended journeys."
  },
  {
    WhyChooseheading: "Easy Booking Assistance",
    WhyChoosedescription: "Get support for vehicle selection, fare details, and travel planning for your Belgaum to Murudeshwar cab requirement."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Murudeshwar Cab Service?",
    answer: "Yes, we provide Belgaum to Murudeshwar taxi services with comfortable vehicles and professional drivers for coastal travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Murudeshwar?",
    answer: "Yes, one-way taxi service is available for passengers looking for direct travel without a return trip."
  },
  {
    question: "Which vehicles are available for Belgaum to Murudeshwar travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles based on your travel needs."
  },
  {
    question: "Is this cab service suitable for family trips?",
    answer: "Yes, spacious cars with comfortable seating are available for family holidays, temple visits, and sightseeing journeys."
  },
  {
    question: "Can I book a round-trip taxi from Belgaum to Murudeshwar?",
    answer: "Yes, return journey options are available with flexible schedules according to your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport?",
    answer: "Yes, airport pickup and drop facilities are available from Belgaum Airport to Murudeshwar and nearby destinations."
  },
  {
    question: "Is Murudeshwar cab service available for sightseeing?",
    answer: "Yes, cabs can be arranged for sightseeing trips and nearby attractions around Murudeshwar."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable tolls, parking fees, and additional charges depend on the selected travel package and are explained during booking."
  },
  {
    question: "Can senior citizens travel comfortably in this cab service?",
    answer: "Yes, comfortable vehicles and experienced drivers make the journey convenient for senior citizens and families."
  },
  {
    question: "How can I book a Belgaum to Murudeshwar Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to get fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback: "The Belgaum to Murudeshwar journey was comfortable and enjoyable. The driver was helpful, and the car was clean throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Asha Kulkarni",
    feedback: "Our family coastal trip was made easier with this taxi service. The vehicle was spacious, and the complete journey was managed professionally.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Murudeshwar Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-murudeshwar-cab.webp",
  "description":
    "Book Belgaum to Murudeshwar Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Murudeshwar with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for pilgrimage trips, family travel, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-murudeshwar-cab"
  }
};





    return (
        <div>


<Helmet>
  <title>Belgaum to Murudeshwar Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Murudeshwar Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Murudeshwar with Sedan, Ertiga, SUV, Innova, and Innova Crysta for pilgrimage, family trips, and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Murudeshwar Cab, Belgaum to Murudeshwar Taxi, Belgaum to Murudeshwar Cab Service, Belgaum to Murudeshwar Taxi Service, Belgaum to Murudeshwar One Way Cab, Belgaum to Murudeshwar Cab Booking, Belgaum to Murudeshwar Car Rental, Belgaum to Murudeshwar Outstation Cab, Belgaum to Murudeshwar Taxi Fare, Belgaum Murudeshwar Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomurudeshwarcab;